module.exports = __webpack_public_path__ + "img/horizontal_7_7_7016.0b1ccc5e.png";